import { keyframes } from '@emotion/react';
import type { LoaderProps } from '@hover/blueprint';
import { Loader } from '@hover/blueprint';
import { forwardRef } from '@hover/blueprint/chakra';
import React from 'react';

interface AnimatedTextProps extends LoaderProps {}

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const FastLoader = forwardRef<AnimatedTextProps, 'div'>((props, ref) => (
  <Loader
    size="huge"
    sx={{
      animationDuration: '750ms',
      animationIterationCount: 'infinite',
      animationName: spin.toString(),
      animationTimingFunction: 'linear',
    }}
    transform="translateY(100%)"
    {...props}
    ref={ref}
  />
));

export { FastLoader };
